
export default function AboutSection() {

  return (
    <section id="about" className="about">
      <div className="about-art">
      <div className="about-label">TWO MINDS. ONE VERY COLORFUL IDEA.</div>
      <img src="/assets/green-logo-mini@4x.png" alt="The Two of Us interwoven symbol" loading="lazy" />
      <div className="about-bottom">
      <span>YOU + ME</span>
      <span>= THE TWO OF US</span>
      </div>
      </div>
      <div className="about-copy">
      <p className="eyebrow">TWO FRIENDS. ONE COLORFUL IDEA.</p>
      <h2>From the<br />two of us.</h2>
      <p>Two friends. A shared love for creating. And an idea to make everyday things feel a little more special.</p>
      <p>The Two of Us is our space to turn those ideas into things you can wear, give, and make your own. We're starting with sweatshirts, with tees and paper goods waiting in the wings.</p>
      <p className="signoff">From the two of us, to you. ♡</p>
      </div>
      </section>

  );
}
